import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditCataegoryPageNew from "../../components/Category/AddCategoryPageNew";



const EditCategoryPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Category" link2="/category" title="Edit Category" />

        {/* AddUserLayer */}
        <EditCataegoryPageNew />


      </MasterLayout>
    </>
  );
};

export default EditCategoryPage;
